import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Label, Alert } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import addToMailchimp from 'gatsby-plugin-mailchimp';

class SubscribeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      email: ``,
      firstname: ``,
      lastname: ``,
      status: ``
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      email: ``,
      firstname: ``,
      lastname: ``,
      status: ``
    });
  }

  _emailChangeHander = e => {
    this.setState({ email: e.target.value });
  }

  _firstnameChangeHander = e => {
    this.setState({ firstname: e.target.value });
  }

  _lastnameChangeHander = e => {
    this.setState({ lastname: e.target.value });
  }

  _postEmailToMailchimp = (email, attributes) => {
    addToMailchimp(email, attributes)
      .then(result => {
        if (result.result !== `success`) {
          this.setState({
            status: `error`
          })
        } else {
          this.setState({
            status: `success`
          })
        }
      })
      .catch(err => {
        alert(err);
      })
  }

  checkValidEmail = (email) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return regex.test(email) ? true : false
  }

  checkMissingNames = (firstname, lastname) => {
    if (firstname.trim() != `` && lastname.trim() != ``) {
      return true;
    }
    return false;
  }

  _handleFormSubmit = e => {
    e.preventDefault()
    e.stopPropagation()

    if (this.checkValidEmail(this.state.email) && this.checkMissingNames(this.state.firstname, this.state.lastname)) {

      this.setState(
        {
          status: `sending`
        },
        this._postEmailToMailchimp(this.state.email, {
          FNAME: this.state.firstname,
          LNAME: this.state.lastname
        })
      )
    }
    else {
      this.setState(
        {
          status: `missing`
      })
      return false;
    }

  }

  render() {

    let errorAlertClass = this.state.status === `error` ? null : 'd-none';
    let missingAlertClass = this.state.status === `missing` ? null : 'd-none';
    let loadingAlertClass = this.state.status === `sending` ? null : 'd-none';
    let successAlertClass = this.state.status === `success` ? null : 'd-none';
    let hideWhenSuccess = this.state.status === `success` ? 'd-none' : null;
    let showWhenSuccess = this.state.status === `success` ? null : 'd-none';

    return (
      <div>
        <Button className="btn-cto bold w-100" color="warning" onClick={this.toggle}><FormattedMessage id="subscribe.label" /></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}><span className="bold"><FormattedMessage id="subscribe.label" /></span></ModalHeader>
          <Form>
            <ModalBody>
              <Alert color="danger" className={errorAlertClass}>{this.state.email} <FormattedMessage id="failedSubscription" /></Alert>
              <Alert color="danger" className={missingAlertClass}><FormattedMessage id="missingSubscription" /></Alert>
              <Alert color="primary" className={loadingAlertClass}><FormattedMessage id="sendingSubscription" /></Alert>
              <Alert color="success" className={successAlertClass}>{this.state.email} <FormattedMessage id="successSubscription" /></Alert>
              <div className={hideWhenSuccess}>
                <FormGroup>
                  <Label><FormattedMessage id="email" /></Label>
                  <Input type="email" autoComplete="email" onChange={this._emailChangeHander} required />
                </FormGroup>
                <FormGroup>
                  <Label><FormattedMessage id="firstname" /></Label>
                  <Input type="text" autoComplete="given-name" onChange={this._firstnameChangeHander} required />
                </FormGroup>
                <FormGroup>
                  <Label><FormattedMessage id="lastname" /></Label>
                  <Input type="text" autoComplete="family-name" onChange={this._lastnameChangeHander} required />
                </FormGroup>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle} className={hideWhenSuccess}><FormattedMessage id="cancel" /></Button>
              <Button type="submit" color="primary" onClick={this._handleFormSubmit} className={hideWhenSuccess}><FormattedMessage id="subscribe.button" /></Button>
              <Button color="secondary" onClick={this.toggle} className={showWhenSuccess}><FormattedMessage id="close" /></Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default SubscribeModal;


// WEBPACK FOOTER //
// ./src/components/Footer/SubscribeModal.js